import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ArticlePage from "../pages/article/page";
import SearchPage from "../pages/search/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import SiteLayout from "../components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <SiteLayout>
        <Home />
      </SiteLayout>
    ),
  },
  {
    path: "/category/:slug",
    element: (
      <SiteLayout>
        <CategoryPage />
      </SiteLayout>
    ),
  },
  {
    path: "/article/:slug",
    element: (
      <SiteLayout>
        <ArticlePage />
      </SiteLayout>
    ),
  },
  {
    path: "/search",
    element: (
      <SiteLayout>
        <SearchPage />
      </SiteLayout>
    ),
  },
  {
    path: "/faq",
    element: (
      <SiteLayout>
        <FaqPage />
      </SiteLayout>
    ),
  },
  {
    path: "/about",
    element: (
      <SiteLayout>
        <AboutPage />
      </SiteLayout>
    ),
  },
  {
    path: "/contact",
    element: (
      <SiteLayout>
        <ContactPage />
      </SiteLayout>
    ),
  },
  {
    path: "*",
    element: (
      <SiteLayout>
        <NotFound />
      </SiteLayout>
    ),
  },
];

export default routes;